import ApiBaseService from './ApiBaseService';

class TransactionService {

    static getTransactionList([data]) {
        return ApiBaseService.request('/api/web/transaction/list', 'POST', data);
    }

    static getTransactionDetailsByUuid([transactionId]) {
        return ApiBaseService.request(`/api/web/transaction/details/${transactionId}`, 'GET');
    }

    static getSlotBookingDetails([bookingId]) {
        return ApiBaseService.request(`/api/web/slot_booking/details/${bookingId}`, 'GET');
    }

    static getBoardBookingDetails([bookingId]) {
        return ApiBaseService.request(`/api/web/board_booking/details/${bookingId}`, 'GET');
    }

    static getTransferSettlement([data]) {
        return ApiBaseService.request(`/api/web/settled/transfer`, 'POST', data);
    }

}

export default TransactionService;